var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{class:{
      'is-Active': _vm.searchParams.start_datetime === _vm.item.start && _vm.searchParams.end_datetime === _vm.item.end,
    },on:{"click":function($event){return _vm.filter({ start_datetime: _vm.item.start, end_datetime: _vm.item.end })}}},[_vm._v(_vm._s(_vm.$store.getters.getStringTranslation(_vm.item.label.replace(/\s/g, '').toLowerCase())))])])
}
var staticRenderFns = []

export { render, staticRenderFns }